/**
 * API configuration — single source of truth for backend connectivity.
 * Values are read from environment variables (REACT_APP_ prefix for CRA).
 */
const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const CHAT_BASE_URL = `${BACKEND_BASE_URL}/chat`;
const AGENT_BASE_URL = `${BACKEND_BASE_URL}/connect-agent`;
const SFDC_CHECK_USER_URL = `${BACKEND_BASE_URL}/api/sfdc/check-user`;
const ATTACHMENT_UPLOAD_URL = `${BACKEND_BASE_URL}/api/attachments/upload`;
const API_TOKEN = process.env.REACT_APP_BACKEND_TOKEN;

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

export {
  BACKEND_BASE_URL,
  CHAT_BASE_URL,
  AGENT_BASE_URL,
  SFDC_CHECK_USER_URL,
  ATTACHMENT_UPLOAD_URL,
  API_TOKEN,
  DEFAULT_HEADERS,
};
